/* eslint-disable @typescript-eslint/no-throw-literal */
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { CheckUpPropertyMeasurement, IFetchCheckUpPropertiesParams } from '~/interfaces'
import { fetchCheckUpProperties, message } from '~/services'

const UNIQUE_KEY = 'checkUpProperties'

export const useFetchCheckUpProperties = (
  fetchParams: IFetchCheckUpPropertiesParams | null,
  config?: UseQueryOptions<CheckUpPropertyMeasurement[], Error, CheckUpPropertyMeasurement[]>
): UseQueryResult<CheckUpPropertyMeasurement[], Error> => {
  const fetcher = async (params: IFetchCheckUpPropertiesParams): Promise<CheckUpPropertyMeasurement[]> => {
    try {
      const response = await fetchCheckUpProperties(params)
      const isResponseEmpty = response.length === 0

      if (isResponseEmpty) {
        throw message('analyticalModels.checkup_not_found')
      }

      return response
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  return useQuery<CheckUpPropertyMeasurement[], Error>(
    [UNIQUE_KEY, fetchParams],
    async () => await fetcher(fetchParams as IFetchCheckUpPropertiesParams),
    {
      enabled: !!fetchParams,
      cacheTime: Infinity,
      staleTime: Infinity,
      ...config
    }
  )
}
